import React, { useEffect } from "react";
import ButtonLoader from "./ButtonLoader";

// Minimal reusable confirmation modal — this codebase had no confirm-before-
// destructive-action pattern anywhere (not even for tenant suspend), so this
// is the first of its kind here. Kept generic (title/message/confirm label)
// so it can be reused for future destructive actions beyond tenant delete.
// isConfirming keeps the modal open with a spinner while the caller's async
// onConfirm is in flight, instead of the modal vanishing instantly and
// leaving the user staring at a seemingly frozen page until the row updates.
const ConfirmDialog = ({ open, title, message, confirmLabel = "Confirm", cancelLabel = "Cancel", danger, isConfirming, onConfirm, onCancel }) => {
  useEffect(() => {
    if (!open || isConfirming) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onCancel();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open, isConfirming, onCancel]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
      <div className="bg-canvas-white rounded p-6 w-full max-w-sm flex flex-col gap-4">
        <h4 id="confirm-dialog-title" className="text-canvas-primary">{title}</h4>
        <h6 className="text-canvas-directoryText font-normal">{message}</h6>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={isConfirming}
            className="font-outfit text-[12px] uppercase font-bold border border-canvas-primary text-canvas-primary py-2 px-5 rounded disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isConfirming}
            className={`flex items-center justify-center gap-2 font-outfit text-[12px] uppercase font-bold text-canvas-white py-2 px-5 rounded disabled:opacity-50 disabled:cursor-not-allowed ${
              danger ? "bg-canvas-danger" : "bg-canvas-primary"
            }`}
          >
            {isConfirming && <ButtonLoader />}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
